


































































































import { Component, Vue, Provide,Prop ,Watch} from "vue-property-decorator";
import {  timeFormat ,timeFormatDay} from "@/utils";
import { GenderEnum } from "@/enum/index";
const deleteDialog = () => import("@/views/peopleManagement/components/deleteDialog.vue");
@Component({
  name: "CombinationProperty",
  components: { deleteDialog }
  
})

export default class CombinationProperty extends Vue {
    @Provide() private avatarUrl: string = '';//头像url
    // @Provide() private showAvatarDialog: Boolean = false;//是否头像弹出框

    @Provide() private dialogVisible: Boolean = false;//delete dialog
    @Provide() private detailForm: any = {};//submit loading
    @Provide() private type:string = 'add'

    @Prop() baseAdd: any;
    @Prop() baseDetail: any;
    @Prop() detailInfo: any;
    @Prop() baseUserInfo: any;
    @Prop() baseLoading: any;
    
    //基础信息
    @Provide() private baseForm: any = {
        name : '' ,
        gender : '' ,
        birthday : '' ,
        mobile : '' ,
        email : '' ,
        panelstatus : 0,
    };

    @Provide() private rules: any =  {
        name: [
            { required: true, message: 'Please enter', trigger: 'blur' },
        ],
        gender: [
            { required: true, message: 'Please enter', trigger: 'blur' },
        ],
        mobile: [
            { required: true, message: 'Please enter', trigger: 'blur' },
        ],
        email: [
            { required: true, message: 'Please enter', trigger: 'blur' },
            {
                min: 1,
                max: 49,
                message: "the length have to be less than 50 letter",
                trigger: "blur",
            },
        ],
    };
    @Watch("detailInfo")
    onDetailInfoChanged(val: any) {
        if (val) {
            this.$nextTick(()=>{
                this.type = 'look'
                this.detailInfo.personal.gender == 0 ? this.detailInfo.personal.gender = '' : this.detailInfo.personal.gender
                this.detailForm = JSON.parse(JSON.stringify(this.detailInfo.personal))
                this.baseForm = JSON.parse(JSON.stringify(this.detailInfo.personal))
                // 格式化生日
                if(this.detailInfo.personal.birthday != 0){
                    let birth = String(this.detailInfo.personal.birthday)
                    this.detailForm.birthday = birth.slice(0,4) + '-' + birth.slice(4,6) + '-' + birth.slice(6,8)
                    // this.baseForm.birthday = birth.slice(0,4) + '-' + birth.slice(4,6) + '-' + birth.slice(6,8)
                }else{
                    this.detailForm.birthday = ''
                    // this.baseForm.birthday = ''
                }
                this.$emit('initForm',this.baseForm,'1')
            })
            
        }
    }
    private mounted () {
        // 如果新增进来，默认赋值，如果详情进来，先赋值，watch监听会改变其赋值为最新的值
        this.$nextTick(()=>{
            this.baseForm.email = this.baseUserInfo.common.email
            this.baseForm.name = this.baseUserInfo.common.name
            this.baseForm.mobile = this.baseUserInfo.mobile
            this.$emit('initForm',this.baseForm,'1')
        })  
    }

     // submit
    private submitForm(formName:string){
        let ref: any = this.$refs[formName];
        ref.validate((valid:any) => {
            if (valid) {
                let formObj:any = {
                    name : this.baseForm.name,
                    gender : +this.baseForm.gender,
                    birthday : this.baseForm.birthday ? Number(timeFormatDay(this.baseForm.birthday).replace(/-/g,'')) : 0,
                    mobile : this.baseForm.mobile ,
                    email : this.baseForm.email ,
                    panelstatus : 0,
                }
                this.$emit('submitForm',formObj,'1')
            } else {
                return false;
            }
        });
    }

    // reset
    private  resetForm(formName:string) {
        if(this.type === 'add'){
            let ref: any = this.$refs[formName];
            ref.resetFields();
        }
        this.$emit('resetForm','1')
    }

    // show add
    private addInfo() {
        this.type = 'add'
        this.$emit('addForm','1')
    }

    // edit
    private editInfo () {
        this.baseForm = JSON.parse(JSON.stringify(this.detailInfo.personal))
        // 格式化生日
        if(this.detailInfo.personal.birthday != 0){
            let birth = String(this.detailInfo.personal.birthday)
            this.baseForm.birthday = birth.slice(0,4) + '-' + birth.slice(4,6) + '-' + birth.slice(6,8)
        }else{
            this.baseForm.birthday = ''
        }
        this.$emit('editForm','1')
    }

    private deleteInfo () {
        //弹框提示是否删除
        this.dialogVisible = true
    }
    private cancelConfirm () {
        this.dialogVisible = false
    }
    private deleteConfirm () {
        this.dialogVisible = false
        this.$emit('deleteForm','1')
    }
   
    private dateChange (val:any) {
        this.$forceUpdate()
    }   

    // private handleAvatarSuccess (res:any,file:any) {
    //     this.avatarUrl = URL.createObjectURL(file.raw)
    // }

    // private  beforeAvatarUpload (file:any) {
    //     const isJPG = file.type === 'image/jpeg';
    //     const isLt2M = file.size / 1024 / 1024 < 2;

    //     if (!isJPG) {
    //         this.$message.error('上传头像图片只能是 JPG 格式!');
    //     }
    //     if (!isLt2M) {
    //         this.$message.error('上传头像图片大小不能超过 2MB!');
    //     }
    //     return isJPG && isLt2M;
    // }

    // private handleRemove(file:any, fileList:any) {
    // }

    // private handlePreview(file:any) {
    // }
    

    // private handleExceed(files:any, fileList:any) {
    //     this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    // }
    // private beforeRemove(file:any, fileList:any) {
    //     return this.$confirm(`确定移除 ${ file.name }？`);
    // }
}
